import { Carousel, Container, MenuItemsCarousel } from '@peracto/peracto-blocks'
import Embed from './Embed'

export default {
    plugins: {
        content: [Carousel, MenuItemsCarousel, Embed],
        layout: [Container],
    },
}
